(function () {
  'use strict';

  const CONFIG = {
    pdfLibs: {
      jspdf: 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js',
      autotable: 'https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.5.25/jspdf.plugin.autotable.min.js'
    },

    prayers: [
      { key: 'Fajr', label: 'Fajr', emoji: '🌅' },
      { key: 'Sunrise', label: 'Sunrise', emoji: '☀️' },
      { key: 'Dhuhr', label: 'Dhuhr', emoji: '🕛' },
      { key: 'Asr', label: 'Asr', emoji: '🌤️' },
      { key: 'Maghrib', label: 'Maghrib', emoji: '🌇' },
      { key: 'Isha', label: 'Isha', emoji: '🌙' }
    ],

    actualPrayers: ['Fajr', 'Dhuhr', 'Asr', 'Maghrib', 'Isha']
  };

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function getApiDate(date) {
    return [pad(date.getDate()), pad(date.getMonth() + 1), date.getFullYear()].join('-');
  }

  function formatTime(time) {
    if (!time) return '--';

    const clean = String(time).replace(/\s*\(.+\)$/, '').trim();
    const parts = clean.split(':');

    if (parts.length < 2) return clean;

    let hours = parseInt(parts[0], 10);
    const minutes = parts[1];

    if (Number.isNaN(hours)) return clean;

    const period = hours >= 12 ? 'PM' : 'AM';

    hours %= 12;
    if (hours === 0) hours = 12;

    return `${hours}:${minutes} ${period}`;
  }

  function timeToMinutes(time) {
    if (!time) return null;

    const parts = String(time).replace(/\s*\(.+\)$/, '').trim().split(':');

    if (parts.length < 2) return null;

    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);

    if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;

    return hours * 60 + minutes;
  }

  function formatDisplayDate(date, timezone) {
    try {
      return new Intl.DateTimeFormat('en-GB', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: timezone
      }).format(date);
    } catch (error) {
      return new Intl.DateTimeFormat('en-GB', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }).format(date);
    }
  }

  function getTimePartsInTimezone(timezone) {
    const now = new Date();

    try {
      const formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      });

      const parts = formatter.formatToParts(now);
      const result = {};

      parts.forEach(function (part) {
        if (part.type !== 'literal') {
          result[part.type] = parseInt(part.value, 10);
        }
      });

      return result;
    } catch (error) {
      const local = new Date();

      return {
        year: local.getFullYear(),
        month: local.getMonth() + 1,
        day: local.getDate(),
        hour: local.getHours(),
        minute: local.getMinutes(),
        second: local.getSeconds()
      };
    }
  }

  function getCurrentMinutes(timezone) {
    const parts = getTimePartsInTimezone(timezone);
    return parts.hour * 60 + parts.minute + parts.second / 60;
  }

  function getPrayerState(timings, timezone) {
    if (!timezone) return null;

    const currentMinutes = getCurrentMinutes(timezone);

    const prayers = CONFIG.actualPrayers
      .map(function (key) {
        return { key: key, time: timings[key], minutes: timeToMinutes(timings[key]) };
      })
      .filter(function (item) {
        return item.minutes !== null;
      });

    if (!prayers.length) return null;

    const nextPrayer = prayers.find(function (prayer) {
      return prayer.minutes > currentMinutes;
    });

    if (!nextPrayer) {
      return { current: prayers[prayers.length - 1], next: prayers[0], nextTomorrow: true };
    }

    let currentPrayer = null;

    prayers.forEach(function (prayer) {
      if (prayer.minutes <= currentMinutes) {
        currentPrayer = prayer;
      }
    });

    if (!currentPrayer) {
      currentPrayer = prayers[prayers.length - 1];
    }

    return { current: currentPrayer, next: nextPrayer, nextTomorrow: false };
  }

  function getMinutesUntilNextPrayer(prayerMinutes, timezone, tomorrow) {
    const current = getCurrentMinutes(timezone);

    if (tomorrow) {
      return (24 * 60 - current) + prayerMinutes;
    }

    return prayerMinutes - current;
  }

  function formatCountdown(totalMinutes) {
    if (totalMinutes === null || totalMinutes < 0) return '--';

    const rounded = Math.ceil(totalMinutes);
    const hours = Math.floor(rounded / 60);
    const minutes = rounded % 60;

    if (hours <= 0) return `${minutes} min`;
    if (minutes <= 0) return `${hours} hr`;

    return `${hours} hr ${minutes} min`;
  }

  function getCalcConfig(root) {
    const method = parseInt(root.dataset.calculationMethod, 10);
    const school = parseInt(root.dataset.calculationSchool, 10);

    return {
      method: Number.isFinite(method) ? method : 3,
      school: Number.isFinite(school) ? school : 0
    };
  }

  function getPrayerOpts(root) {
    const { method, school } = getCalcConfig(root);

    return {
      latitude: parseFloat(root.dataset.latitude),
      longitude: parseFloat(root.dataset.longitude),
      method: method,
      school: school
    };
  }

  function setLoading(root, loading) {
    const element = root.querySelector('[data-salah-loading]');
    if (element) element.hidden = !loading;
  }

  function showError(root, message) {
    const element = root.querySelector('[data-salah-error]');
    if (!element) return;

    element.textContent = message;
    element.hidden = false;
  }

  function hideError(root) {
    const element = root.querySelector('[data-salah-error]');
    if (!element) return;

    element.hidden = true;
    element.textContent = '';
  }

  function showStatus(root, message) {
    const element = root.querySelector('[data-salah-status]');
    if (!element) return;

    element.textContent = message;
    element.hidden = !message;
  }

  function updateDate(root, date, timezone) {
    const element = root.querySelector('[data-salah-date]');
    if (element) element.textContent = formatDisplayDate(date, timezone);
  }

  const PRAYER_STATUS_LABELS = { current: 'Now', next: 'Next', passed: 'Passed' };

  // 'current', 'next', 'passed', or '' for a prayer still to come later today.
  function getPrayerStatus(prayerKey, timings, state, timezone) {
    if (!state || !timezone) return '';
    if (state.current && state.current.key === prayerKey) return 'current';
    if (!state.nextTomorrow && state.next && state.next.key === prayerKey) return 'next';

    const minutes = timeToMinutes(timings[prayerKey]);
    if (minutes !== null && minutes <= getCurrentMinutes(timezone)) return 'passed';

    return '';
  }

  function createPrayerStatus(status) {
    const badge = document.createElement('span');
    badge.className = `salah-times__prayer-status salah-times__prayer-status--${status || 'empty'}`;

    if (status) {
      badge.textContent = PRAYER_STATUS_LABELS[status];
    } else {
      badge.setAttribute('aria-hidden', 'true');
    }

    return badge;
  }

  function renderPrayerTimes(root, timings) {
    const container = root.querySelector('[data-salah-prayers]');
    if (!container) return;

    const state = getPrayerState(timings, root.dataset.timezone);
    const currentKey = (state && state.current && state.current.key) || '';
    const fragment = document.createDocumentFragment();

    CONFIG.prayers.forEach(function (prayer) {
      const item = document.createElement('div');
      item.className = 'salah-times__prayer';

      if (prayer.key === currentKey) item.classList.add('is-current');

      const status = getPrayerStatus(prayer.key, timings, state, root.dataset.timezone);
      if (status === 'passed') item.classList.add('is-passed');

      const name = document.createElement('span');
      name.className = 'salah-times__prayer-name';

      const emoji = document.createElement('span');
      emoji.className = 'salah-times__prayer-emoji';
      emoji.setAttribute('aria-hidden', 'true');
      emoji.textContent = prayer.emoji || '';

      const label = document.createElement('span');
      label.textContent = prayer.label;

      name.appendChild(emoji);
      name.appendChild(label);

      const time = document.createElement('span');
      time.className = 'salah-times__prayer-time';
      time.textContent = formatTime(timings[prayer.key]);

      item.appendChild(createPrayerStatus(status));
      item.appendChild(name);
      item.appendChild(time);
      fragment.appendChild(item);
    });

    container.replaceChildren(fragment);
  }

  function renderPrayerState(root, timings, timezone) {
    const nextContainer = root.querySelector('[data-salah-next]');
    if (!nextContainer) return;

    const state = getPrayerState(timings, timezone);

    if (!state || !state.next) {
      nextContainer.hidden = true;
      return;
    }

    const name = root.querySelector('[data-salah-next-name]');
    const time = root.querySelector('[data-salah-next-time]');
    const countdown = root.querySelector('[data-salah-countdown]');

    const label = CONFIG.prayers.find(function (item) {
      return item.key === state.next.key;
    });

    if (name) name.textContent = label ? label.label : state.next.key;
    if (time) time.textContent = formatTime(state.next.time);

    if (countdown) {
      countdown.textContent = formatCountdown(
        getMinutesUntilNextPrayer(state.next.minutes, timezone, state.nextTomorrow)
      );
    }

    nextContainer.hidden = false;
  }

  function renderJumma(root, weekday, timings) {
    const container = root.querySelector('[data-salah-jumma]');
    if (!container) return;

    const isFriday = weekday === 'Friday';
    const dhuhrTime = timings ? timings.Dhuhr : null;

    if (!isFriday || !dhuhrTime) {
      container.hidden = true;
      return;
    }

    const time = root.querySelector('[data-salah-jumma-time]');
    if (time) time.textContent = formatTime(dhuhrTime);

    container.hidden = false;
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      const existing = document.querySelector(`script[src="${src}"]`);

      if (existing) {
        if (existing.dataset.salahLoaded === 'true') {
          resolve();
          return;
        }

        existing.addEventListener('load', function () {
          resolve();
        });

        existing.addEventListener('error', function () {
          reject(new Error(`Failed to load ${src}`));
        });

        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.async = true;

      script.addEventListener('load', function () {
        script.dataset.salahLoaded = 'true';
        resolve();
      });

      script.addEventListener('error', function () {
        reject(new Error(`Failed to load ${src}`));
      });

      document.head.appendChild(script);
    });
  }

  let pdfLibsPromise = null;

  function loadPdfLibraries() {
    if (!pdfLibsPromise) {
      pdfLibsPromise = loadScript(CONFIG.pdfLibs.jspdf)
        .then(function () {
          return loadScript(CONFIG.pdfLibs.autotable);
        })
        .catch(function (error) {
          pdfLibsPromise = null;
          throw error;
        });
    }

    return pdfLibsPromise;
  }

  function loadImageAsDataUrl(src) {
    return new Promise(function (resolve, reject) {
      if (!src) {
        resolve(null);
        return;
      }

      const image = new Image();
      image.crossOrigin = 'anonymous';

      image.onload = function () {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = image.naturalWidth || image.width;
          canvas.height = image.naturalHeight || image.height;

          const context = canvas.getContext('2d');

          if (!context) {
            reject(new Error('Canvas is not supported.'));
            return;
          }

          context.drawImage(image, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        } catch (error) {
          reject(error);
        }
      };

      image.onerror = function () {
        reject(new Error('Unable to load logo.'));
      };

      image.src = src;
    });
  }

  async function buildTimetablePdf(city, country, range, days, logoUrl) {
    const jsPDFCtor = window.jspdf && window.jspdf.jsPDF;

    if (!jsPDFCtor) {
      throw new Error('PDF library did not load correctly.');
    }

    const doc = new jsPDFCtor({ orientation: 'portrait', unit: 'pt', format: 'a4' });

    const rangeLabel = range === 'daily' ? 'Daily' : range === 'weekly' ? 'Weekly' : 'Monthly';
    const title = `${city} Prayer Timetable`;
    const subtitleParts = [rangeLabel];

    if (country) subtitleParts.push(country);

    const subtitle = subtitleParts.join(' - ');

    const headerLeft = 20;
    const logoWidth = 160;
    const logoHeight = 76;
    const logoTop = 10;
    const titleX = headerLeft + logoWidth + 10;
    const titleY = 45;
    const subtitleY = 64;

    let logoAdded = false;

    if (logoUrl) {
      try {
        const logoDataUrl = await loadImageAsDataUrl(logoUrl);

        if (logoDataUrl) {
          doc.addImage(logoDataUrl, 'PNG', headerLeft, logoTop, logoWidth, logoHeight);
          logoAdded = true;
        }
      } catch (error) {
        console.warn('Logo could not be added to PDF:', error);
      }
    }

    const finalTitleX = logoAdded ? titleX : headerLeft;

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(18);
    doc.setTextColor(30, 14, 75);
    doc.text(title, finalTitleX, titleY);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(11);
    doc.setTextColor(103, 108, 118);
    doc.text(subtitle, finalTitleX, subtitleY);

    const head = [['Date', 'Day', 'Fajr', 'Sunrise', 'Dhuhr', 'Asr', 'Maghrib', 'Isha', "Jumu'ah"]];

    const body = days.map(function (day) {
      const weekday =
        day.date && day.date.gregorian && day.date.gregorian.weekday
          ? day.date.gregorian.weekday.en
          : '';

      const dateLabel = day.date && day.date.gregorian ? day.date.gregorian.date : '';
      const timings = day.timings || {};
      const isFriday = weekday === 'Friday';

      return [
        dateLabel,
        weekday,
        formatTime(timings.Fajr),
        formatTime(timings.Sunrise),
        formatTime(timings.Dhuhr),
        formatTime(timings.Asr),
        formatTime(timings.Maghrib),
        formatTime(timings.Isha),
        isFriday ? formatTime(timings.Dhuhr) : '-'
      ];
    });

    const tableStartY = logoAdded ? 92 : 82;

    doc.autoTable({
      head: head,
      body: body,
      startY: tableStartY,
      styles: { font: 'helvetica', fontSize: 9, cellPadding: 6, textColor: [30, 14, 75] },
      headStyles: { fillColor: [30, 14, 75], textColor: [255, 255, 255] },
      alternateRowStyles: { fillColor: [238, 241, 249] },
      margin: { left: 40, right: 40 }
    });

    const finalY = (doc.lastAutoTable && doc.lastAutoTable.finalY) || tableStartY;

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(103, 108, 118);
    doc.text(
      "Jumu'ah time is estimated from Dhuhr. Please confirm the khutbah time with your local mosque.",
      40,
      finalY + 22,
      { maxWidth: 515 }
    );

    const filenameCity = city.toLowerCase().replace(/[^a-z0-9]+/g, '-');
    const filenameDate = getApiDate(new Date()).split('-').reverse().join('-');

    doc.save(`salah-times-${filenameCity}-${range}-${filenameDate}.pdf`);
  }

  async function downloadTimetable(root, range) {
    const current = root._salahCurrentData;

    if (!current || !current.timings) {
      showError(root, 'Prayer times are not loaded yet.');
      return;
    }

    const button = root.querySelector(`[data-salah-download-pdf="${range}"]`);
    const originalLabel = button ? button.textContent : '';

    if (button) {
      button.disabled = true;
      button.textContent = 'Preparing…';
    }

    hideError(root);

    try {
      await loadPdfLibraries();

      const prayerOpts = getPrayerOpts(root);
      const cityName = root.dataset.cityName || '';
      const countryName = root.dataset.countryName || '';

      let days;

      if (range === 'daily') {
        days = [
          {
            date: {
              gregorian: {
                date: getApiDate(current.date),
                weekday: { en: current.weekday || '' }
              }
            },
            timings: current.timings
          }
        ];
      } else if (range === 'weekly') {
        days = await window.SalahData.getDayRange(prayerOpts, current.date, 7);
      } else if (range === 'monthly') {
        days = await window.SalahData.getCalendarMonth(
          prayerOpts,
          current.date.getFullYear(),
          current.date.getMonth() + 1
        );
      } else {
        throw new Error('Unknown timetable range.');
      }

      if (!days || !days.length) {
        throw new Error('No timetable data available.');
      }

      const logoUrl = root.dataset.salahLogoUrl || '';

      await buildTimetablePdf(cityName, countryName, range, days, logoUrl);
    } catch (error) {
      console.error('Timetable download error:', error);
      showError(root, 'Unable to prepare the timetable right now. Please try again.');
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = originalLabel;
      }
    }
  }

  function renderMosques(root, mosques) {
    const container = root.querySelector('[data-salah-mosques]');
    if (!container) return;

    if (!mosques || !mosques.length) {
      container.replaceChildren();

      const item = document.createElement('li');
      item.className = 'salah-times__mosque';

      const name = document.createElement('span');
      name.className = 'salah-times__mosque-name';
      name.textContent = "We couldn't find any listed mosques nearby — check with your local Islamic center.";

      item.appendChild(name);
      container.appendChild(item);
      return;
    }

    const fragment = document.createDocumentFragment();

    mosques.forEach(function (mosque) {
      const item = document.createElement('li');
      item.className = 'salah-times__mosque';

      const name = document.createElement('span');
      name.className = 'salah-times__mosque-name';
      name.textContent = mosque.name;

      item.appendChild(name);

      if (mosque.location) {
        const location = document.createElement('span');
        location.className = 'salah-times__mosque-location';
        location.textContent = mosque.location;
        item.appendChild(location);
      }

      fragment.appendChild(item);
    });

    container.replaceChildren(fragment);
  }

  function getCurrentPosition() {
    return new Promise(function (resolve, reject) {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: false,
        timeout: 10000,
        maximumAge: 300000
      });
    });
  }

  async function useCurrentLocation(root) {
    if (!navigator.geolocation) {
      showError(root, 'Location services are not supported by your browser. Please select a city.');
      return;
    }

    if (root._salahLocationLoading) return;

    root._salahLocationLoading = true;

    hideError(root);
    showStatus(root, 'Getting your current location...');
    setLoading(root, true);

    try {
      const position = await getCurrentPosition();

      if (!root.isConnected) return;

      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;

      let locationInfo;

      try {
        locationInfo = await window.SalahData.reverseGeocode(latitude, longitude);
      } catch (error) {
        console.warn('Reverse geocoding failed:', error);
        locationInfo = { city: 'Your Current Location', country: '', countryCode: '' };
      }

      if (!root.isConnected) return;

      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

      showStatus(root, `Finding the prayer times page for ${locationInfo.city}...`);

      const result = await window.SalahData.resolveCity({
        city: locationInfo.city,
        country: locationInfo.country,
        countryCode: locationInfo.countryCode,
        latitude: latitude,
        longitude: longitude,
        timezone: timezone
      });

      window.location.href = result.url;
    } catch (error) {
      console.error('Geolocation error:', error);

      if (root.isConnected) {
        showStatus(root, '');
        showError(root, 'Location access was not available. Please select your city instead.');
      }
    } finally {
      root._salahLocationLoading = false;

      if (root.isConnected) setLoading(root, false);
    }
  }

  function refreshPrayerStatus(root) {
    if (!root || !root.isConnected || !root._salahCurrentData) return;

    const current = root._salahCurrentData;

    renderPrayerTimes(root, current.timings);
    renderPrayerState(root, current.timings, root.dataset.timezone);
    renderJumma(root, current.weekday, current.timings);
  }

  function startStatusTimer(root) {
    if (root._salahStatusTimer) return;

    function tick() {
      if (!root.isConnected) {
        root._salahStatusTimer = null;
        return;
      }

      refreshPrayerStatus(root);
      root._salahStatusTimer = window.setTimeout(tick, 30000);
    }

    root._salahStatusTimer = window.setTimeout(tick, 30000);
  }

  async function loadPrayerData(root, prayerOpts, timezone, now) {
    setLoading(root, true);

    try {
      const { data } = await window.SalahData.getPrayerDay(prayerOpts, now);

      const weekday =
        data.date && data.date.gregorian && data.date.gregorian.weekday
          ? data.date.gregorian.weekday.en
          : null;

      root._salahCurrentData = { timings: data.timings, weekday: weekday, date: now };

      renderPrayerTimes(root, data.timings);
      renderPrayerState(root, data.timings, timezone);
      renderJumma(root, weekday, data.timings);
      startStatusTimer(root);
    } catch (error) {
      console.error('Salah Times Error:', error);
      showError(root, 'Unable to load prayer times right now. Please try again later.');
    } finally {
      setLoading(root, false);
    }

    window.SalahData.getNearbyMosques(prayerOpts.latitude, prayerOpts.longitude)
      .then(function (mosques) {
        if (root.isConnected) renderMosques(root, mosques);
      })
      .catch(function (error) {
        console.warn('Nearby mosque lookup failed:', error);
        if (root.isConnected) renderMosques(root, []);
      });
  }

  function init(root) {
    if (!root || root.dataset.salahCityInitialized === 'true') return;

    root.dataset.salahCityInitialized = 'true';

    if (!window.SalahData) {
      showError(root, 'Unable to load prayer times right now. Please try again later.');
      return;
    }

    const prayerOpts = getPrayerOpts(root);
    const timezone = root.dataset.timezone || 'UTC';

    if (!Number.isFinite(prayerOpts.latitude) || !Number.isFinite(prayerOpts.longitude)) {
      showError(root, 'This city has not been configured yet.');
      return;
    }

    const now = new Date();

    hideError(root);
    updateDate(root, now, timezone);

    // Crawlers and headless browsers would otherwise spend third-party API quota.
    if (!window.SalahData.isLikelyBot()) {
      loadPrayerData(root, prayerOpts, timezone, now);
    }

    root.querySelectorAll('[data-salah-download-pdf]').forEach(function (button) {
      button.addEventListener('click', function () {
        downloadTimetable(root, button.dataset.salahDownloadPdf);
      });
    });

    const locationButton = root.querySelector('[data-salah-location-button]');

    if (locationButton) {
      locationButton.addEventListener('click', function () {
        useCurrentLocation(root);
      });
    }

    const citySelect = root.querySelector('[data-salah-city-select]');

    if (citySelect) {
      citySelect.addEventListener('change', function () {
        if (citySelect.value === 'current-location') {
          useCurrentLocation(root);
          return;
        }

        window.location.href = citySelect.value;
      });
    }
  }

  function initializeAll() {
    document.querySelectorAll('[data-salah-city]').forEach(function (root) {
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }
})();
